import React from 'react';

const Module = () => {

    return (
        <>
          <section id="container" className="wrap">
            <div className="paragraph">
              <h1 className="subject"><strong>SKYTONE</strong></h1>
              <h2 className="title">모듈 조립</h2>
              <p className="desc">스카이톤 조립은 크게 두 가지로 나뉩니다.<br/>
                모듈 조립과 액자 조립 입니다.<br/>
                조립을 위해서는 별도의 공구가 필요 하지 않습니다.<br/><br/>             
                <strong>* 조립 전 전원을 연결하지 마세요!!</strong><br/>
                (잘못된 연결로 인해 기판이 손상될 수 있습니다.)
              </p>
            </div> 
            <div className="page-content">
              <div className="content-group">                        
                <div className="paragraph">
                  <p className="step">01</p>
                  <p className="desc"><i className="mark"><img src={process.env.PUBLIC_URL + '/src/mark-a.png'} alt="A"/></i>, <i className="mark"><img src={process.env.PUBLIC_URL + '/src/mark-b.png'} alt="B"/></i> 를 결합해 주세요.</p>
                </div>
                <div className="screenshot w100">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/module-01.png'} alt=""/>
                </div>       
              </div>   
              <div className="content-group">                        
                <div className="paragraph">
                  <p className="step">02</p>
                  <p className="desc"><i className="mark"><img src={process.env.PUBLIC_URL + '/src/mark-c.png'} alt="C"/></i>, <i className="mark"><img src={process.env.PUBLIC_URL + '/src/mark-e.png'} alt="E"/></i> 를 준비해 주세요.<br/><small>* <strong>E</strong> 패널들을 프레임에서 분리하고, 부착된 보호 비닐이 있다면 떼어주세요.</small><small>** 색상은 예시와 다를 수 있습니다.</small></p>
                </div>
                <div className="screenshot w100">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/module-02.png'} alt=""/>
                </div>       
              </div>   
              <div className="content-group">                        
                <div className="paragraph">
                  <p className="step">03</p>
                  <p className="desc"><i className="mark"><img src={process.env.PUBLIC_URL + '/src/mark-e.png'} alt="E"/></i> 패널을 순서에 맞게 쌓아주세요. 순서는 아래와 같습니다.</p>
                </div>
                <div className="screenshot w100">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/module-04.gif'} alt=""/>
                </div>       
              </div>   
              <div className="content-group">                        
                <div className="paragraph">
                  <p className="step">04</p>
                  <p className="desc">패널 순서를 확인한 뒤, 5개의 나사로 고정합니다.</p>
                </div>
                <div className="screenshot w100">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/module-03.png'} alt=""/>
                </div>    
              </div>   
              <div className="content-group">                        
                <div className="paragraph">
                  <p className="step">05</p>
                  <p className="desc">모듈 조립이 완성되었어요!</p>
                </div>
                <div className="screenshot w100">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/module-05.png'} alt=""/>
                </div>      
              </div>
              <div className="content-group">                        
                <div className="paragraph">
                  <p className="step">06</p>
                  <p className="desc"><i className="mark"><img src={process.env.PUBLIC_URL + '/src/mark-g.png'} alt="G"/></i> - 모듈과 고정판을 2개의 나사로 고정해주세요.<br/><small>* 하단에 나사구멍이 있습니다.</small></p>
                </div>
                <div className="screenshot w100">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/module-06.png'} alt=""/>
                </div>       
              </div>
            </div>
            <span className="empty-space"></span>
          </section>
        </>
    );
};

export default Module;